import { PATHS } from '../paths';
import { OrderId } from '@interfaces/order';

export default (httpClient: any, baseUrl = PATHS.BASE_URL) => ({
  triggerIpSending(orderId: OrderId) {
    return httpClient.post(`${baseUrl}${PATHS.IP(orderId)}`, {});
  },
});
